module.exports = __webpack_public_path__ + "img/icon-fg_t.2890a237.png";